<template>
	
	<section class="hero" v-if="ndf">
		<div class="hero-body">
			<div class="container">
				<nav class="breadcrumb" aria-label="breadcrumbs">
					<ul>
						<li><router-link to="/">Notes de frais</router-link></li>
						<li class="is-active"><a>{{ ndf.libelle }}</a></li>
					</ul>
				</nav>

				<h1 class="title is-1">
					{{ ndf.libelle }}
				</h1>
				<p class="subtitle is-3">
					<b class="has-text-grey-light">{{ ndf.personne }}</b> / <span class="has-text-grey-light">{{ ndf.support }} {{ ndf.projet }}</span>
				</p>
				<template v-if="ndf.upload_mobile == 1">
<!-- 					<nav class="is-mobile">
						<div>
							HT:&nbsp;<span class="has-text-grey-light">{{ ndf.HT }}</span>
						</div>
						<div>
							TVA:&nbsp;<span class="has-text-grey-light">{{ ndf.TVA }}</span>
						</div>
						<div>
							TTC:&nbsp;<span class="has-text-grey-light">{{ ndf.TTC }}</span>
						</div>
					</nav>
					<hr>
 -->
 					<p v-if="depensesSansJustificatifs">Il y a {{ depensesSansJustificatifs }} sans justificatif dans cette note de frais. Cliquez sur une dépense ci-dessous pour y associer un justificatif.</p>
					<p v-else>
						Toutes les dépenses de cette note de frais ont un justificatif.
					</p>
					<br>
					<router-link :to="{ name: 'Depense', params : {id:depense.id} }" class="box content" v-for="depense in ndf.depenses">
						<article class="post">
							<h4>{{ depense.libelle }}</h4>
							<nav class="level is-size-7	is-mobile">
								<div class="level-item">
									HT:&nbsp;<span class="has-text-grey-light">{{ depense.HT }}</span>
								</div>
								<div class="level-item">
									TVA:&nbsp;<span class="has-text-grey-light">{{ depense.TVA }}</span>
								</div>
								<div class="level-item">
									TTC:&nbsp;<span class="has-text-grey-light">{{ depense.TTC }}</span>
								</div>
							</nav>

							<div class="media is-size-7">
								<div class="media-left">
									{{ depense.type_depense_icone }}
								</div>
								<div class="media-content">
									<div class="content ">
										<p>
											{{ depense.date }} &nbsp;
										</p>
									</div>
								</div>
								<div class="media-right">
									<button v-if="!depense.justificatif" class="button is-danger is-small">
										<span class="icon is-small">
											<i class="fas fa-exclamation-triangle"></i>
										</span>
										<span>Justificatif manquant</span>
									</button>
									<code v-else> {{ basename(depense.justificatif) }}</code>

								</div>
							</div>
						</article>
					</router-link>
				</template>
				<template v-else>
					<b>Import inactif</b>
					<p>
						Activez l'import de documents par mobile pour cette note de frais en cliquant sur 
						&laquo; <b>📲 Importer les justificatifs</b> &raquo;
						dans SOGEST.
					</p>
					<br>
					<button @click="reload" class="button is-primary">
						<span class="icon is-small">
							<i class="fas fa-sync-alt"></i>
						</span>
						<span>Recharger la page</span>
					</button>

				</template>
			</div>
		</div>
	</section>

</template>

<script>
	export default {
		name: 'Ndf',
		data() {
			return {
				ndf:false
			}
		},
		computed: {
			depensesSansJustificatifs() {
				let nb = 0;
				this.ndf.depenses.forEach(function(depense) {
					if(!depense.justificatif) {
						nb++;
					}
				})
				if(nb) {	
					return nb+' dépense'+(nb>1 ? 's' : '');
				}
			}
		},
		methods : {
			reload() {
				document.location.reload()
			},
			chargerNdf() {
				window.axios.post('ndf',{clause : {
					id:this.$route.params.id
				}}).then(response => {
					this.ndf = response.data.ndf[0]
				});
			}
		},
		mounted() {
			this.chargerNdf();
			let ci = setInterval(() => {
				if(this.ndf.upload_mobile != 1) {
					this.chargerNdf();
				} else {
					clearInterval(ci);
				}
			},5000);
		}
	}
</script>

<style>
article.post {
	overflow: hidden;
	text-overflow: ellipsis;
}
</style>


// WEBPACK FOOTER //
// src/components/Ndf.vue